import ping from '@databases/ping-registry';

import { type PresenceState } from './presence-state.ts';
import { isCellGrouping, isColumnGrouping, isRowGrouping } from './utils.ts';

/**
 * Branches presence-store changes into the ping registry, which drives the
 * per-component `usePresence` React path (cell / row / column nameplates).
 *
 * On every store change it pings only the affected component. This is the
 * legacy live-presence subscriber; the drawable renderer is the other
 * subscriber.
 *
 * Returns an unsubscribe function.
 */
export function startPresenceComponentPings(presence: PresenceState): () => void {
  return presence.subscribe((grouping) => {
    const participants = presence.getParticipantsFromGrouping(grouping);

    let pingKey: ReturnType<typeof ping.key<'cell' | 'column' | 'row'>> | undefined;

    if (isCellGrouping(grouping)) {
      pingKey = ping.key('cell', grouping);
    } else if (isColumnGrouping(grouping)) {
      pingKey = ping.key('column', grouping);
    } else if (isRowGrouping(grouping)) {
      pingKey = ping.key('row', grouping);
    }

    if (pingKey) {
      ping.notify(pingKey, 'presence', participants);
    }
  });
}
